import { Notificacion } from "@components/general/Alertas/Alertas";
import {
  deactivatePublicacion,
  reactivatePublicacion,
} from "@helpers/httpRequests/httpRequestsForoEmpresarial/httpRequestsForoEmpresarial";
import React from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const ReactivarPublicacion = ({ setPublicacionReactivada, publicacion }) => {

  const {t} = useTranslation();

  const { idPublicacion } = publicacion;
  // console.log(idPublicacion);

  const cancelarRehabilitarPublicacion = () => {
    Notificacion("info", t('businessForum.noReactivated'));
  };

  const RehabilitarPublicacion = async () => {
    try {
      const { message, data } = await reactivatePublicacion(idPublicacion);
      // console.log(data);
      setPublicacionReactivada(true);
      Notificacion("success", message);
    } catch (error) {
      Notificacion("error", "Error al rehabilitar la publicación");
    }
  };

  return (
    <Container fluid className="text-center">
      <h3>{t('businessForum.reactivatePostConfirmation')}</h3>

      <Row className="pt-3">
        <Col>
          <Button variant="success" onClick={RehabilitarPublicacion}>
            {t('businessForum.confirmReactivatePost')}
          </Button>
        </Col>

        <Col>
          <Button variant="danger" onClick={cancelarRehabilitarPublicacion}>
            {t('businessForum.cancelReactivatePost')}
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default ReactivarPublicacion;
